import { render } from "./brandlist.vue?vue&type=template&id=6b31bf9f"
import script from "./brandlist.vue?vue&type=script&lang=js"
export * from "./brandlist.vue?vue&type=script&lang=js"

import "./brandlist.vue?vue&type=style&index=0&id=6b31bf9f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__